import { Users, Mail, Crown, Calendar } from 'lucide-react';

export default function AdminSubscribers({ subscribers }) {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold flex items-center gap-2">
          <Users className="w-5 h-5 text-purple-400" /> Fan Subscribers
        </h2>
        <span className="text-sm text-gray-400">{subscribers.length} total</span>
      </div>

      {subscribers.length === 0 ? (
        <div className="glass-card p-8 text-center">
          <Users className="w-12 h-12 text-gray-600 mx-auto mb-4" />
          <h3 className="text-lg font-semibold mb-2">No Subscribers Yet</h3>
          <p className="text-gray-400">Fans will appear here when they subscribe</p>
        </div>
      ) : (
        <div className="space-y-2">
          {subscribers.map(sub => (
            <div key={sub.id || sub.email} className="glass-card p-4 flex items-center gap-4" data-testid={`subscriber-${sub.email}`}>
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center">
                <span className="text-white font-bold">{(sub.name || sub.email || '?')[0].toUpperCase()}</span>
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="font-medium truncate">{sub.name || 'Anonymous'}</h4>
                <p className="text-sm text-gray-400 flex items-center gap-1">
                  <Mail className="w-3 h-3" /> {sub.email}
                </p>
              </div>
              <div className="text-right">
                <span className={`px-2 py-1 rounded-full text-xs ${sub.tier === 'premium' ? 'bg-yellow-500/20 text-yellow-400' : 'bg-gray-500/20 text-gray-400'}`}>
                  {sub.tier === 'premium' && <Crown className="w-3 h-3 inline mr-1" />}
                  {sub.tier || 'free'}
                </span>
                {sub.created_at && (
                  <p className="text-xs text-gray-500 mt-1 flex items-center gap-1 justify-end">
                    <Calendar className="w-3 h-3" />
                    {new Date(sub.created_at).toLocaleDateString()}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
